export default __webpack_public_path__ + "locales/zh-CN/RoomLogoCover.json?hash=f7b91d8e7d6885609256307e37583cf7";